import React from 'react';
import { UserCheck } from 'lucide-react';

export const LoginScreen = ({ onGoogleLogin, onGodModeLogin, isDarkMode, loginLogo }) => {
    // Verifica se o sistema está rodando no ambiente de produção (Firebase ou domínio próprio)
    const isProduction = window.location.hostname.includes('web.app') || 
                         window.location.hostname.includes('firebaseapp.com') || 
                         window.location.hostname.includes('grupoacad.com.br');

    return (
        <div className={`min-h-screen w-full flex items-center justify-center transition-colors duration-300 ${isDarkMode ? 'bg-slate-950 text-white' : 'bg-slate-50 text-slate-900'}`}>
            <div className={`w-full max-w-md p-8 rounded-3xl shadow-2xl border flex flex-col items-center text-center animate-fade-in ${isDarkMode ? 'bg-slate-900 border-slate-800' : 'bg-white border-gray-200'}`}>
                
                <img 
                    src={loginLogo || "/LogoApEx2.0.png"} 
                    alt="Logo apEx Grupo Acad" 
                    className="w-48 h-auto mb-6 transform hover:scale-105 transition-transform drop-shadow-md" 
                />
                
                <p className={`text-sm mb-10 font-medium ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}></p>

                {/* Botão Google Principal */}
                <button 
                    onClick={() => onGoogleLogin(false)} 
                    className={`w-full flex items-center justify-center gap-3 px-4 py-3.5 rounded-xl font-bold transition-all shadow-sm hover:shadow-md mb-3 border ${isDarkMode ? 'bg-slate-800 border-slate-700 hover:bg-slate-700 text-white' : 'bg-white border-gray-300 hover:bg-gray-50 text-gray-800'}`}
                >
                    <svg className="w-5 h-5" viewBox="0 0 24 24">
                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                    </svg>
                    Continuar com Google
                </button>

                {/* NOVA OPÇÃO: Entrar com outra conta */}
                <button 
                    onClick={() => onGoogleLogin(true)} 
                    className="text-sm font-bold text-blue-600 hover:text-blue-700 transition-colors mb-6"
                >
                    Entrar com outra conta do Google
                </button>

                {/* === MOSTRA O MODO DEUS APENAS SE NÃO FOR PRODUÇÃO === */}
                {!isProduction && (
                    <>
                        <div className={`w-full h-px mb-6 ${isDarkMode ? 'bg-slate-800' : 'bg-gray-100'}`}></div>

                        <button 
                            onClick={onGodModeLogin} 
                            className={`w-full flex items-center justify-center gap-3 px-4 py-3.5 rounded-xl font-bold transition-all shadow-sm hover:shadow-md border border-transparent ${isDarkMode ? 'bg-indigo-600 hover:bg-indigo-500 text-white' : 'bg-slate-900 hover:bg-slate-800 text-white'}`}
                        >
                            <UserCheck size={18} />
                            Acesso Deus (Preview Mode)
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default LoginScreen;
